import * as React from 'react';

import Icon from '../../Icon';
import Clear from '../../Clear';
import Checkbox from '../../CheckBox';

import toggleClass from '../../dom/toggleClass';

export default class Sorter extends React.Component {
  constructor(props) {
    super(props);
    let currentAppliedFilters = this.props.choices
      .filter((el) => {
        return el.is_selected === true;
      })
      .map((el) => {
        return el.value;
      });
    this.state = { isOpened: false, filtersQuery: [...currentAppliedFilters] };
  }

  toggleFilterBody() {
    this.setState({
      isOpened: !this.state.isOpened,
    });
    toggleClass({
      elId: 'js-document-wrapper',
      className: 'overlay-active',
    });

    document
      .querySelector('#js-document-wrapper')
      .addEventListener('click', (e) => {
        let el = e.target;
        if (el.className === 'document overlay-active') {
          this.toggleFilterBody();
        }
      });
  }

  toggleFiltersQuery(value, checked) {
    this.setState(
      (prevState) => ({
        filtersQuery: value,
      }),
      () => {
        this.applyFilterQuery();
      }
    );
  }

  renderFilterBodyItems(choices) {
    return choices.map((choice, index) => {
      return (
        <div className='item' key={index}>
          <Checkbox
            name='filter'
            icon='check'
            checked={choice.is_selected}
            value={choice.value}
            onChange={(checked) =>
              this.toggleFiltersQuery(choice.value, checked)
            }
          >
            <span className='float-left'>
              {choice.label} <em>{choice.quantity}</em>
            </span>
          </Checkbox>
        </div>
      );
    });
  }

  applyFilterQuery() {
    this.toggleFilterBody();
    this.props.applyFilterQuery(this.state.filtersQuery);
  }

  render() {
    let { isOpened } = this.state;
    let { title, iconClosed, iconOpened, choices } = this.props;
    return (
      <div
        className={'filter ' + (isOpened ? 'opened' : '')}
        onClick={(e) => {
          e.preventDefault();
          this.toggleFilterBody();
        }}
      >
        <span className='title'>{title}</span>
        {!isOpened && iconClosed ? <Icon icon={iconClosed} /> : ''}
        {isOpened && iconOpened ? <Icon icon={iconOpened} /> : ''}
        <div className='body'>
          <div className='body-inner'>
            {this.renderFilterBodyItems(choices)}
          </div>
          <Clear />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/product/list/Sorter.js